import { ClientI18NProvider } from '@susu/i18n/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { MemoryRouter, Route, Routes } from 'react-router-dom'
import { resolvePageLanguage } from './lib/locale-resolver'
import { translations } from './locales'
import Index from './pages/Index'
import NotFound from './pages/NotFound'

const queryClient = new QueryClient()

export default function App() {
  // The page locale, resolved once: ?language > URL locale > <html lang> > en.
  // It deliberately does not follow the language dropdown — that one is the
  // customer's email preference, not the language this page is written in.
  const language = resolvePageLanguage() || 'en'

  return (
    <QueryClientProvider client={queryClient}>
      <ClientI18NProvider language={language} messages={translations}>
        <MemoryRouter>
          <Routes>
            <Route path="/" element={<Index />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </MemoryRouter>
      </ClientI18NProvider>
    </QueryClientProvider>
  )
}
